import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
// import StackCard from "./stackCard";

function Hero() {
  let letterRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    // Get all the letter elements inside letterRef
    const letters = letterRef.current.querySelectorAll("[data-char]");

    // Animate each letter from the top to its position
    gsap.fromTo(
      letters,
      {
        y: -50, // animate from 50px above
        opacity: 0,
      },
      {
        y: 0, // animate to original position
        opacity: 1,
        stagger: 0.1,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: letterRef.current,
          start: "top 75%",
        },
      }
    );
  }, []);

  return (
    <div className="md:py-20 py-10 overflow-hidden container mx-auto">
      <div className="lg:flex flex-row overflow-hidden">
        <div className="flex flex-row lg:gap-4 gap-0 px-4 lg:px-0 items-start text-left">
          <div className="w-1 mt-2 h-9 bg-blue-500"></div>
          <div className="flex flex-col gap-1 items-start">
            <span className="lg:text-5xl text-2xl font-bold text-fontPrimary leading-normal">
              Empowering businesses
            </span>
            <span className="lg:text-5xl text-2xl font-bold text-fontPrimary">
              globally through seamless
            </span>
            <div>
              <h3
                className="flex flex-row gap-1 overflow-hidden lg:text-5xl text-2xl pb-2 leading-relaxed font-bold text-blue-500"
                ref={letterRef}
              >
                <div data-char="d">d</div>
                <div data-char="e">e</div>
                <div data-char="v">v</div>
                <div data-char="e">e</div>
                <div data-char="l">l</div>
                <div data-char="o">o</div>
                <div data-char="p">p</div>
                <div data-char="i">i</div>
                <div data-char="n">n</div>
                <div data-char="g">g</div>
                <div style={{ marginLeft: "10px" }}></div>
                <div data-char="s">s</div>
                <div data-char="o">o</div>
                <div data-char="l">l</div>
                <div data-char="u">u</div>
                <div data-char="t">t</div>
                <div data-char="i">i</div>
                <div data-char="o">o</div>
                <div data-char="n">n</div>
                <div data-char="s">s</div>
              </h3>
            </div>
            <p className="text-fontPrimary font-normal text-sm overflow-hidden">
              Elevating Ideas with Flawless <b>Design</b> and{" "}
              <b>Agile Development</b>.
            </p>
          </div>
        </div>
        <div className="absolute lg:w-[800px] lg:h-[800px] h-60 w-80 top-[-40px] right-0 overflow-hidden">
          <div className="lg:w-[680px] lg:h-[750px] h-60 w-40 absolute lg:right-[-100px] lg:top-[-150px] rounded-dot1 bg-blue-200 opacity-20 rotate-[20deg] animate-animatedot1"></div>
          <div className="absolute top-0 lg:w-[650px] lg:h-[750px] h-60 w-40 lg:right-[-100px] lg:top-[-150px]  rounded-dot2 bg-orange-200 opacity-20 rotate-[161deg] animate-animatedot2"></div>
          <div className="absolute top-0 lg:w-[680px] lg:h-[750px] h-60 w-40 lg:right-[-100px] lg:top-[-150px]  rounded-dot3 bg-green-200 opacity-20 rotate-[50deg] animate-animatedot3"></div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
